<script>
import Button from '@/components/Button'

export default
{
    name: 'message-card',

    props:
    {
        icon: { type: String, required: false },
        message: { type: String, required: true },
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class='message-card'>
                <inline-svg v-show={this.icon} src={this.icon} class='icon' />
                <p class='message'>{ this.message }</p>
                <Button v-show={this.$listeners['action-click']} text="Retourner à l'accueil" on-click={this.onActionClicked} />        
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    methods:
    {
        onActionClicked (event)
        {
            this.$emit('action-click', event)
        }
    },

    components:
    {
        Button
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.message-card
{
    background: var(--theme-content-background-color);
    border-radius: 4px;
    padding: 10%;

    .OnLargeMobile({ padding: 7%; });

    .icon
    {
        height: auto;
        margin-bottom: 4vh;
        fill: var(--theme-accent-color);
        width: 45%;
        margin-left: 27.5%;

        .OnTablet({
            width: 35%;
            margin-left: 32.5%;
        });

        .OnDesktop({
            width: 30%;
            margin-left: 35%;
        });
    }

    .message
    {
        font-family: Nunito;
        color: var(--theme-text-color-light);
        text-align: center;
        font-weight: bold;
        margin-bottom: 8vh;
        font-size: 5vw;

        .OnTablet({ font-size: 4vw; });
        .OnDesktop({ font-size: 2vw; });
        .OnLarge({ font-size: 1.5vw; });
    }

    .button
    {
        width: 100%;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/MessageCard.vue